export function providerIsEnabled(provider) {
  const name = String(provider ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return !['changee', 'coincraddle', 'coincradle', 'xgram', 'goexme'].includes(name);
}

export function rateIsFixed(value) {
  if (value === true || String(value).toLowerCase() === 'true') return true;
  if (value === false || String(value).toLowerCase() === 'false') return false;
  throw new Error('The provider quote has no valid rate type. Please get fresh rates.');
}

export function providerErrorMessage(body, status) {
  const detail = typeof body === 'string' ? body :
    body?.error?.message || body?.error?.detail || body?.error || body?.message || body?.detail;
  if (typeof detail === 'string' && detail.trim() && !/<(?:!doctype|html|body)\b/i.test(detail)) {
    return `Provider rejected the request (${status}): ${detail.trim().slice(0, 500)}`;
  }
  return `Provider rejected the request (${status}). Check the address and network, get fresh rates, or choose another provider.`;
}

export async function confirmProviderTrade(input) {
  if (!providerIsEnabled(input.provider)) throw new Error('This provider is no longer available. Please choose another provider.');
  const values = {
    id: input.tradeId, ticker_from: input.tickerFrom, ticker_to: input.tickerTo,
    network_from: input.networkFrom, network_to: input.networkTo,
    amount_from: input.amountFrom, address: input.address?.trim(), provider: input.provider,
    fixed: String(rateIsFixed(input.fixed)),
  };
  if (!values.address) throw new Error('Please enter recipient address');
  if (input.refund?.trim()) values.refund = input.refund.trim();
  const url = new URL('https://server.ghostswap.app/api/trocador/new_trade');
  url.search = new URLSearchParams(values).toString();
  // Never retry a confirmation automatically: the first request may have succeeded.
  const response = await fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' }, cache: 'no-store' });
  const text = await response.text();
  let body;
  try { body = JSON.parse(text); } catch { body = text; }
  if (!response.ok) throw new Error(providerErrorMessage(body, response.status));
  if (!body || typeof body !== 'object') throw new Error('The provider returned an unreadable response. Check this order’s status before retrying.');
  return body;
}
